import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { httpOk, GET, POST } from 'helpers/api'
import { formatMoney } from 'helpers/helpers'

// Погашение долга организации её баллами кэшбэка (plan-org-cashback-bot.md, решения 6 и 10).
// Не деньги: касса и смена не затрагиваются, в ОПиУ сумма идёт расходом на лояльность.
// Погасить можно не больше долга и не больше баллов; `onRedeemed` обновляет карточку и список.
function LoyaltyRedeem({ organization, onRedeemed }) {
	const { t } = useTranslation()

	const [info, setInfo] = useState(null)
	const [amount, setAmount] = useState('')

	async function getInfo() {
		if (!organization.id) return
		const response = await GET(`/organizations-loyalty-redeem?organization_id=${organization.id}`)
		if (httpOk(response)) {
			setInfo(response.data)
			setAmount(response.data.max > 0 ? String(Math.floor(response.data.max)) : '')
		}
	}

	async function redeem() {
		const response = await POST('/organizations-loyalty-redeem', {
			'organization_id': organization.id,
			'amount': Number(amount),
		}, { loader: true })

		if (httpOk(response)) {
			await getInfo()
			if (onRedeemed) onRedeemed(response.data)
		}
	}

	useEffect(() => {
		setInfo(null)
		getInfo()
	}, [organization.id]) // eslint-disable-line react-hooks/exhaustive-deps

	if (!info) return null

	return (
		<div className="mt-4">
			<h6>{t('org_redeem_title')}</h6>
			<div className="d-flex justify-content-between mb-1">
				<span>{t('org_redeem_points')}</span>
				<b>{formatMoney(info.points)}</b>
			</div>
			<div className="d-flex justify-content-between mb-2">
				<span>{t('org_redeem_debt')}</span>
				<b>{formatMoney(info.debt)}</b>
			</div>

			{info.max > 0 ?
				<>
					<div className="d-flex gap-2">
						<input type="text" className="form-control" value={amount}
							onChange={(e) => {
								const value = e.target.value.replace(/[^0-9.]/g, '')
								if (Number(value) > info.max) return
								setAmount(value)
							}} />
						<button type="button" className="btn btn-outline-secondary text-nowrap"
							onClick={() => setAmount(String(info.max))}>
							{t('org_redeem_all')}
						</button>
						<button type="button" className="btn btn-primary text-nowrap"
							disabled={!(Number(amount) > 0)} onClick={redeem}>
							{t('org_redeem_button')}
						</button>
					</div>
					<small className="text-muted d-block mt-1">{t('org_redeem_hint')}</small>
				</>
				:
				<small className="text-muted">{t('org_redeem_none')}</small>
			}
		</div>
	)
}

export default LoyaltyRedeem
